<template>
  <div class="search main" :class="$store.state.theme">
    <MainBackButton />

    <div class="subtitle">
      {{ $t("home2.search") }}
      <span class="region link is-pulled-right" @click="toggleGlobalSearch">
        <span v-if="isGlobalSearch">Global</span>
        <span v-else>{{ translateRegion($store.state.region) }}</span>
      </span>
    </div>

    <div class="field" style="margin-bottom: 0px">
      <p class="control has-icons-left has-icons-right">
        <input type="text" ref="input" class="input is-large is-light has-text-dark" v-model="searchVal"
          :placeholder="searchPlaceholder" @keyup="search($event.target.value)" @focus="search($event.target.value)" />
        <span class="icon is-small is-left search-icon" @click="triggerSearch">
          <i class="fa fa-search fa-sm" :class="{ 'has-text-warning': isOutdatedSearch }" />
        </span>
        <span v-if="searchTerm" class="icon is-small is-right clear-search">
          <i class="fa fa-times-circle" @click="clearSearch" />
        </span>
      </p>
    </div>

    <div class="result-header tabs is-fullwidth">
      <ul>
        <li :class="{ 'is-active': searchTab === 'shops' }" @click="setTab('shops')">
          <a>{{ $t("search.shops") }}</a>
        </li>
        <li :class="{ 'is-active': searchTab === 'menu' }" @click="setTab('menu')">
          <a>{{ $t("search.menu-items") }}</a>
        </li>
      </ul>
    </div>

    <div class="scroll-list no-scrollbar">
      <div v-if="searchTab === 'shops'">
        <div v-if="searchResult.length">
          <div class="list is-hoverable">
            <span v-for="s in visibleShops" v-ripple class="list-item single-line is-flex" :key="s.key + s.value"
              @click="select(s)">
              <span class="flex-img-wrapper">
                <img v-if="s.pic" :src="s.pic" />
                <img v-else :src="shopImg" class="no-pic" />
                <span v-if="s.hidden" class="hidden-tag"><i class="fa fa-eye-slash" /></span>
              </span>
              <span class="flex-name">{{ s.key }}</span>
            </span>
          </div>
          <div v-if="isCommerceAgent && hiddenShops && hiddenShops.length" class="list is-hoverable">
            <span class="list-item hidden-shop has-text-centered" @click="showHiddenShops = !showHiddenShops">
              <i class="far fa-eye-slash fa-sm" />&nbsp;Hidden Shops
              <b>{{ hiddenShops.length }}</b>
              <i v-if="showHiddenShops" class="fa fa-chevron-up" />
              <i v-else class="fa fa-chevron-down" />
            </span>

            <span v-if="showHiddenShops">
              <span><span v-for="s in hiddenShops" v-ripple class="list-item single-line is-flex hidden-shop"
                  :key="s.key + s.value" @click="select(s)">
                  <span class="flex-img-wrapper">
                    <img v-if="s.pic" :src="s.pic" />
                    <img v-else :src="shopImg" class="no-pic" />
                    <span v-if="s.hidden" class="hidden-tag"><i class="fa fa-eye-slash" /></span>
                  </span>
                  <span class="flex-name">{{ s.key }}</span>
                </span></span>
            </span>
          </div>
        </div>
        <div v-else>
          <div v-if="isSearching" class="list">
            <span class="list-item" style="padding: 12px">
              <span style="opacity: 0.1 !important">
                <b-skeleton height="24px" />
              </span>
            </span>
          </div>
          <div v-else class="list" @click="clearSearch">
            <span class="list-item is-italic has-text-grey" style="padding: 12px">
              <i v-if="searchTerm">{{ $t("home2.no-results-for") }} "{{ searchTerm }}"</i>
              <i v-else>Search for shops</i>
            </span>
          </div>
        </div>
      </div>

      <div v-if="searchTab === 'menu'">
        <div v-if="menuItems">
          <div class="list is-hoverable">
            <!-- <span
              v-for="s in visibleShops"
              v-ripple
              class="list-item single-line is-flex"
              :key="s.key + s.value"
              @click="select(s)"
            >
              <span class="flex-img-wrapper">
                <img v-if="s.pic" :src="s.pic" />
                <img v-else :src="shopImg" class="no-pic" />
                <span v-if="s.hidden" class="hidden-tag"
                  ><i class="fa fa-eye-slash"
                /></span>
              </span>
              <span class="flex-name">{{ s.key }}</span>
            </span> -->

            <span v-for="(s, i) in menuItems" v-ripple class="list-item single-line is-flex" :key="'menuItems' + i"
              @click="selectWithSearch(s)">
              <!-- <i class="fa fa-list fa-sm" style="opacity: 0.4; margin-right: 8px" /> -->
              <span class="flex-img-wrapper">
                <img v-if="s.business_pic" :src="s.business_pic" />
                <img v-else :src="shopImg" class="no-pic" />
              </span>
              <span class="flex-name">{{ s.business_name }}</span>
              <span class="flex-count">
                <span class="tag is-medium is-rounded">{{ s.count }}</span>
              </span>
              <!-- <span class="business-name">{{ s.business_name }}</span> -->
              <!-- <span class="is-pulled-right tag is-rounded">{{ s.count }}</span> -->
            </span>
          </div>
        </div>
        <div v-else class="list" @click="clearSearch">
          <span class="list-item is-italic has-text-grey" style="padding: 12px">
            <i v-if="searchTerm">{{ $t("home2.no-results-for") }} "{{ searchTerm }}"</i>
            <i v-else>Search for menu items</i>
          </span>
        </div>
      </div>

      <div v-if="searchTab === 'categories'">
        <div class="list">
          <span class="list-item is-italic has-text-grey" style="padding: 12px">
            <i>Categories search coming soon!</i>
          </span>
        </div>
      </div>

      <div v-if="searchTab === 'super'">
        <div class="list">
          <span class="list-item is-italic has-text-grey" style="padding: 12px">
            <i>Search all coming soon! (Superuser)</i>
          </span>
        </div>
      </div>
    </div>

    <div v-if="isSuperUser()" class="users-btn" @click="goto('user_lookup')">
      <i class="far fa-user fa-lg" />
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus.js";
import MainBackButton from "@/components/MainBackButton";

export default {
  name: "Search",
  components: {
    MainBackButton,
  },
  props: {
    id: String,
  },
  data() {
    return {
      isGlobalSearch: false, // for superusers only
      searchTab: "shops",
      menuItems: null,
      searchPlaceholder: this.$t("home2.search"),
      isSearching: false,
      searchResult: [],
      noResults: false,
      searchVal: null,
      searchTerm: null,
      lastSearch: null, // store last search when searchVal/searchTerm clear
      lastSearchVal: null, // try to fix mobile issue
      shopImg: "/img/home2/shop-bw.png",
      typedAt: null,
      showHiddenShops: false,
    };
  },
  computed: {
    isCommerceAgent() {
      // only show hidden shops to commerce agents / superusers
      return this.isSuperUser() || this.$store.getters.isCommerceAgent;
    },
    isOutdatedSearch() {
      if (!this.searchVal || this.searchVal.length < 3) return false;
      return this.lastSearchVal !== this.searchVal.toLowerCase();
    },
    visibleShops() {
      return this.searchResult.filter((s) => {
        if (s.hidden) return false;
        if (!s.pic) return false;
        return true;
      });
    },
    hiddenShops() {
      return this.searchResult.filter((s) => {
        if (s.hidden) return true;
        if (!s.pic) return true;
      });
    },
    frequentShops() {
      return this.$store.getters.getFrequentShops;
    },
    recentShops() {
      // return this.$store.getters.getRecentShops;
      var recent = this.deepCopy(this.$store.state.shopHistory);
      var sorted = recent.sort((a, b) => {
        return b.updated_at - a.updated_at;
      });
      if (sorted.length <= 6) return sorted;
      return sorted.slice(0, 6);
    },
    defaultShops() {
      var combined = this.recentShops.concat(this.frequentShops);
      return combined;
    },
  },
  mounted() {
    this.cycleSearchPlaceholder();
    // this.checkSearchVal(); // hack to fix mobile search

    if (!this.$store.getters.getUserLocation) {
      this.updateLocation();
      EventBus.$emit("OPEN_REGION_MODAL", null);
    } else {
      this.$refs.input.focus();
    }
  },
  activated() {
    if (this.id) {
      this.typedAt = new Date(Date.parse("1999-01-01"));
      this.searchVal = this.id;
      this.search(this.id);
      // or use TukLoader component...
      var loader = this.loadingDots();
      setTimeout(() => loader.hide(), 500);
    }
    //     this.search();
    //     setTimeout(() => this.$refs.input.focus(), 400);
  },
  methods: {
    setTab(tab) {
      this.searchTab = tab;
      this.search(this.searchVal);
    },
    checkSearchVal() {
      setTimeout(() => {
        if (this.searchVal === this.lastSearchVal) return null;
        console.log(`New Search! ${this.searchVal} vs ${this.lastSearchVal}`);
        alert(this.searchVal);
      }, 1000)
    },
    toggleGlobalSearch() {
      if (!this.isSuperUser()) {
        var region = this.translateRegion(this.$store.state.region);
        var msg = "Search near you in " + region; // ใกล้คุณใน
        this.infoToast(msg, "top");
      }
      this.isGlobalSearch = !this.isGlobalSearch;
      if (this.isGlobalSearch) this.infoToast("Search globally", "top");
      else this.infoToast("Search nearby", "top");
    },
    select(s) {
      this.logSearch(s);
      this.$nextTick(() => this.goto(`shop/${s.value}`));
    },
    selectWithSearch(s) {
      this.logSearch(s);
      var path = `shop/${s.business_id}?tab=menu&search=${this.searchTerm}`;
      this.$nextTick(() => this.goto(path));
    },
    logSearch(s) {
      s.term = this.lastSearch;
      this.log("search_success", s);
    },
    validTypingDelay() {
      if (!this.typedAt) this.typedAt = new Date();
      var diff = (new Date().getTime() - this.typedAt.getTime()) / 1000;
      this.typedAt = new Date();
      return diff > 1;
    },
    triggerSearch() {
      // force trigger search by clicking icon
      this.typedAt = new Date(Date.parse("1999-01-01"));
      this.searchResult = [];
      this.search(this.searchVal);
    },
    search(text) {
      if (!text) {
        this.searchResult = this.frequentShops; // this.defaultShops; //
        this.isSearching = false;
        this.noResults = false;
        return;
      }
      this.searchTerm = text; // a hack for mobile...
      this.lastSearch = text;
      console.log("search", text);
      if (text.length < 3) {
        console.log("frequentShops", this.$store.getters.getFrequentShops);
        this.searchResult = this.frequentShops.filter((s) =>
          s.key.toLowerCase().includes(text.toLowerCase())
        );
        this.isSearching = false;
        this.noResults = false;
        return;
      }
      if (!this.validTypingDelay()) return;
      this.lastSearchVal = text;
      // now call search api
      if (this.searchTab === "shops") this.searchBusinesses(text);
      else this.searchMenus(text);
    },
    searchBusinesses(text) {
      this.isSearching = true;
      this.$store
        .dispatch("autocompleteBusinesses", text)
        .then((res) => {
          if (res.data) {
            if (res.data.businesses) {
              this.searchResult = res.data.businesses;
              this.noResults = false;
            } else {
              this.searchResult = [];
              this.noResults = true;
            }
          } else {
            this.searchResult = [];
            this.noResults = true;
          }
        })
        .catch((err) => console.error("searchBusinesses", err))
        .finally(() => (this.isSearching = false));
    },
    searchMenus(text) {
      this.menuItems = null;
      this.$store
        .dispatch("searchMenuItems", text)
        .then((res) => (this.menuItems = res.data)) // no results if this is empty array []
        .catch((err) => console.error("searchAutocomplete", err))
        .finally(() => (this.isSearching = false));
    },
    clearSearch() {
      var delay = 10;
      setTimeout(() => {
        this.searchVal = null;
        this.searchTerm = null;
        this.noResults = false;
        this.searchResult = this.frequentShops;
        this.menuItems = null;
      }, delay);
      setTimeout(() => {
        this.searchResult = [];
        this.$refs.input.focus();
      }, delay);
      //   this.$nextTick(() => (this.searchResult = [])); // don't know why this didn't work
    },
    cycleSearchPlaceholder() {
      var strings = [
        "search-restaurants",
        "search-food",
        "search-shops",
        // "search-services",
        // "search-transport",
        // "search-anything",
        "search",
      ]; // blank at end
      var i = 0;
      setInterval(() => {
        i += 1;
        if (i >= strings.length) i = 0;
        this.searchPlaceholder = this.$t(`home2.${strings[i]}`);
      }, 1500);
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 0;
  height: 100vh;
  width: 100vw;
  /* background-color: #fff5d1; */
  z-index: 4;
  overflow: hidden;
}

.dark.main {
  background-color: #1f1b24;
}

.input {
  border-radius: 0px;
  /* background-color: #ffc800; */
}

.dark .input {
  background-color: #000000;
  border: 1px solid black;
  color: white !important;
}

.dark input::-webkit-input-placeholder {
  color: #666 !important;
}

.subtitle {
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 0;
  text-align: left;
  padding: 16px;
  padding-left: 56px;
  /* background: linear-gradient(0deg,
      rgba(255, 134, 0, 0.6) 0%,
      rgba(255, 194, 0, 1) 100%); */
  background: linear-gradient(0deg,
      #ffc800 0%,
      white 100%);
  /* background-image: url("/img/home2/home-dots-pattern.png");
  background-size: contain;
  background-position: center; */
}

.dark .subtitle {
  color: rgba(255, 255, 255, 0.8);
  background: linear-gradient(0deg,
      var(--crypto-primary) 0%,
      var(--crypto-secondary) 100%);
  /* background-color: var(--crypto-primary); */
}

.delete {
  position: absolute;
  right: 12px;
  top: 12px;
}

.single-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* display: inline-block; */
}

.list {
  border-radius: 0;
  margin-bottom: 0;
  text-align: left;
}

.list-item {
  border-radius: 0;
  border-bottom: 1px solid rgba(238, 238, 238, 0.6);
  padding-right: 8px;
}

/* .list-item:hover {
  outline: 1px solid var(--warning);
} */
.dark .list-item {
  background-color: #1f1b24;
  border-bottom: 1px solid rgba(128, 128, 128, 0.15);
  color: white;
}

.business-name {
  max-width: calc(100vw - 76px);
  display: inline-block;
  vertical-align: bottom;
  overflow: hidden;
  text-overflow: ellipsis;
}

.result-header {
  text-align: left;
  color: rgba(128, 128, 128, 0.9);
  /* padding: 9px 12px; */
  font-weight: 500;
  margin-bottom: 0;
  padding: 0;
}

.dark .result-header {
  background-color: rgba(255, 255, 0, 0);
}

li a {
  color: #aaa;
  padding: 16px;
}

li a:hover {
  color: #777;
  border-bottom: 2px solid #999;
}

li.is-active a {
  color: #333;
  border-bottom: 2px solid #555;
}

.dark li.is-active a {
  color: gold;
  border-bottom: 2px solid gold;
}

.scroll-list {
  max-height: calc(100vh - 120px);
  padding-bottom: 80px;
  overflow: auto;
  margin-top: 1px;
}

.fa-store-alt {
  opacity: 0.4;
  margin-right: 8px;
}

.flex-img-wrapper {
  position: relative;
  flex-shrink: 1;
  object-fit: cover;
  height: 64px;
  width: 64px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
  /* overflow: hidden; */
}

img {
  object-fit: cover;
  height: 64px;
  width: 64px;
}

.flex-name {
  flex: 1;
  padding-left: 9px;
  line-height: 64px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.flex-count {
  flex-shrink: 1;
  padding-right: 9px;
  padding-left: 4px;
  line-height: 64px;
}

.is-flex.list-item {
  padding: 0;
}

.search-icon {
  margin-left: 7px;
  pointer-events: all !important;
  cursor: pointer;
}

.clear-search {
  /* pointer-events: initial; */
  pointer-events: all !important;
  cursor: pointer;
  color: #bbb !important;
}

.no-pic {
  padding: 10px;
  opacity: 0.6;
}

.region {
  font-size: 0.7em;
  margin-top: 2px;
}

.hidden-tag {
  position: absolute;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  padding: 0 3px;
  /* width: 64px; */
  font-size: 0.8em;
  color: white;
  border-bottom-right-radius: 5px;
}

.users-btn {
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 20px;
  color: #aaa;
}

.hidden-shop {
  opacity: 0.95;
  padding: 14px;
  color: grey !important;
  background-color: whitesmoke;
}

.hidden-shop b {
  background-color: white;
  margin: 0 10px;
  border-radius: 10px;
  display: inline-block;
  width: 30px;
}
</style>